import React, { useEffect } from 'react'
import {
  Route,
  Switch,
  Router,
  matchPath,
  withRouter,
} from 'react-router-dom'

import { createTransportContext } from '../utils/transportContext'
import { createFunkGoPage } from '../FunkGoPage'
import { RouterHistoryProvider, customHistory } from './CustomRouterHistoryContext'


/* --------------------------------------- */
const DEFAULT_NOT_FOUND = props => null

const assertMultiPageOptions = ({ router, pluginHub }) => {
  if (!router || !router.routes || !pluginHub) {
    throw new Error('invalid parameter to render multi page elements')
  }
}

/* --------------------------------------- */

const parseRoutes = props => {
  assertMultiPageOptions(props)

  const { router, pluginHub } = props
  const { routes, NotFound } = router

  const routeElements = routes.map(({ component, path, ...rest }) => {
    // 判断是否是异步加载组件，如果是通过render方式 如果不是转成funkgoPage
    if (component.preload && typeof component.preload === 'function') {
      return (
        <Route
          {...rest}
          key={path}
          path={path}
          render={(props) => {
            let Component = component
            if (typeof window !== 'undefined' && window._INIT_DATA) {
              props.data = window._INIT_DATA
            }
            return <Component {...props} />
          }}
        ></Route>
      )
    } else {
      return (
        <Route
          {...rest}
          key={path}
          path={path}
          component={createFunkGoPage(component, pluginHub)}
        ></Route>
      )
    }
  })

  const notFoundRouteElement = (
    <Route
      key='notFound'
      path={null}
      component={NotFound}
    ></Route>
  )

  return {
    routeElements,
    notFoundRouteElement,
  }
}

/* --------------------------------------- */
const createAppShell = ({ AppShell, pluginHub }) => {
  return withRouter(props => {
    const transportContext = createTransportContext(props)
    const pluginProps = pluginHub.getInjectProps(transportContext)

    return (
      <AppShell {...pluginProps}>{props.children}</AppShell>
    )
  })
}

/* --------------------------------------- */
const createRouter = () => props => {
   return (
    <RouterHistoryProvider>
      <Router history={customHistory}>
        {props.children}
      </Router>
    </RouterHistoryProvider>
  )
}

/* --------------------------------------- */

const createPageElements = options => {
  assertMultiPageOptions(options)

  const {
    routeElements,
    notFoundRouteElement,
  } = parseRoutes(options)

  return () => (
    <Switch>
      {routeElements}
      {notFoundRouteElement}
    </Switch>
  )
}

/* --------------------------------------- */

const createMatchPage = options => location => {
  assertMultiPageOptions(options)

  const {
    router,
  } = options

  const {
    routes,
    NotFound = DEFAULT_NOT_FOUND,
  } = router

  let Component
  let statusCode
  let match

  routes.some(route => {
    const pathMatch = matchPath(location.pathname, route)

    if (pathMatch) {
      Component = route.component
      statusCode = 200
      match = pathMatch
    }

    return Boolean(pathMatch)
  })

  if (!Component) {
    Component = NotFound
    statusCode = 404
    match = null
  }

  return {
    Component,
    statusCode,
    match,
  }
}

/* --------------------------------------- */

export {
  createAppShell,
  createRouter,
  createPageElements,
  createMatchPage,
}